import { render, staticRenderFns } from "./DuplicateClientSlot.vue?vue&type=template&id=3a9ae33a&scoped=true"
import script from "./DuplicateClientSlot.vue?vue&type=script&lang=ts"
export * from "./DuplicateClientSlot.vue?vue&type=script&lang=ts"
import style0 from "./DuplicateClientSlot.vue?vue&type=style&index=0&id=3a9ae33a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a9ae33a",
  null
  
)

export default component.exports